import languages from './lng';

// Language hook
class Language {
  exists(context, textId) {
    const transformed = typeof textId === 'string' ? textId.toUpperCase() : '';
    return Boolean(window.app?.language?.dictionary?.[context]?.[transformed]);
  }
  get(context, textId) {
    textId = typeof textId === 'string' ? textId.toUpperCase() : '';
    return window.app?.language?.dictionary?.[context]?.[textId] ||
      `(Undefined text id "${context}/${textId}")`;
  }
}

const useLanguage = (props) => {
  const lngId = window.app?.language?.id || 'en';
  if (props?.languages[lngId]) {
    const merged = Object.keys(props.languages[lngId]).reduce(
      (merged, key) => {
        merged[key] = merged[key] || props.languages[lngId][key];
        return merged;
      },
      window.app?.language?.dictionary || {},
    );
    window.app = {
      ...window.app,
      language: {
        id: lngId,
        dictionary: merged,
      },
    };
  }
  return new Language();
};

// Loading basic common default language
useLanguage({ languages });

export default useLanguage;
